import { useWatch } from 'react-hook-form';

// Import helpers
import { FormFieldsRenderer } from 'components/elements/atoms/HookFormComponents/FormFieldsRenderer/FormFieldsRenderer';

// Import variables
import { FORM_FIELDS } from './variables';

const Fields = () => {
	const type = useWatch({ name: 'client.type' });

	const fields = FORM_FIELDS.filter((field) => field.invoiceType.includes(type));

	return <FormFieldsRenderer fields={fields} />;
};

export default Fields;
